'use es6';

import { Map as ImmutableMap, Set as ImmutableSet } from 'immutable';
import { getFileManagerUrls, getFileById, getFileByPath } from 'FormsUI/api/FileManager';
import { getFileByPath as selectFileByPath } from 'FormsCommonComponents/selectors/FileManager';
import Log from 'forms-utils-lib/logger/Logger';
function createAction(name) {
  return `@@fileManager/${name}`;
}
export const REQUEST_FILE_MANAGER_URLS = createAction('REQUEST_FILE_MANAGER_URLS');
export const RECEIVE_FILE_MANAGER_URLS = createAction('RECEIVE_FILE_MANAGER_URLS');
export const SUCCEED_GETTING_FILE_MANAGER_URLS = createAction('SUCCEED_GETTING_FILE_MANAGER_URLS');
export const FAIL_GETTING_FILE_MANAGER_URLS = createAction('FAIL_GETTING_FILE_MANAGER_URLS');
export const RECEIVE_FILE_BY_PATH = createAction('RECEIVE_FILE_BY_PATH');

// Action creators
function requestFileManagerUrls() {
  return {
    type: REQUEST_FILE_MANAGER_URLS
  };
}
function receiveFileManagerUrls(guidToUrlMap) {
  return {
    type: RECEIVE_FILE_MANAGER_URLS,
    guidToUrlMap
  };
}
function succeedGettingFileManagerUrls() {
  return {
    type: SUCCEED_GETTING_FILE_MANAGER_URLS
  };
}
function failGettingFileManagerUrls() {
  return {
    type: FAIL_GETTING_FILE_MANAGER_URLS
  };
}
function fetchFileManagerUrls(formGuids) {
  return dispatch => {
    dispatch(requestFileManagerUrls());
    getFileManagerUrls(formGuids.toArray()).then(response => {
      dispatch(succeedGettingFileManagerUrls());
      dispatch(receiveFileManagerUrls(ImmutableMap(Object.values(response || {}).filter(res => res).map(({
        name,
        full_path
      }) => [name, full_path]))));
    }).catch(err => {
      dispatch(failGettingFileManagerUrls());
      setTimeout(() => {
        throw err;
      });
    });
    return undefined;
  };
}
export function fetchFileByPath(path) {
  return (dispatch, getState) => {
    if (selectFileByPath(getState(), path)) {
      return;
    }
    const signedUrlRegex = /filemanager\/api\/v2\/files\/([0-9]+)\/signed-url-redirect/g;
    const altSignedUrlRegex = /form-integrations\/v1\/uploaded-files\/signed-url-redirect\/([0-9]+)/g;
    let isSignedUrl = signedUrlRegex.exec(path);
    if (!isSignedUrl || !isSignedUrl[1]) {
      isSignedUrl = altSignedUrlRegex.exec(path);
    }
    if (isSignedUrl && isSignedUrl[1]) {
      getFileById(isSignedUrl[1]).then(file => {
        dispatch({
          type: RECEIVE_FILE_BY_PATH,
          path,
          file
        });
      }).catch(({
        xhr
      }) => {
        Log.logServiceError('Failed to get signed file by ID', xhr);
      });
    } else {
      getFileByPath(path).then(file => {
        dispatch({
          type: RECEIVE_FILE_BY_PATH,
          path,
          file
        });
      }).catch(({
        xhr
      }) => {
        Log.logServiceError('Failed to get file by ID', xhr);
      });
    }
  };
}
export function fetchFileManagerUrl(formGuid) {
  return fetchFileManagerUrls(ImmutableSet([formGuid]));
}